import NovelCard from "./novelcard";


export function VotingGrid({ novels, votes }) {

    const sorted = [...novels].sort(
        (a, b) => (votes[b.id] ?? 0) - (votes[a.id] ?? 0)
    );

    return (
        <div className="grid">
            {sorted.map(vn => (
                <NovelCard
                    key={vn.id}
                    novel={vn}
                    votes={votes[vn.id] ?? 0}
                />
            ))}
        </div>
    );
}
